import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { ModeloRequest, Response } from './Types';

class ModeloController {
  public static async Listar(request: ModeloRequest): Promise<Response> {
    try {
      console.log('Controller Modelo Listar');
      console.log(request);

      const response = await Api.post('api/modelo/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(ModeloId: number): Promise<Response> {
    try {
      console.log('Controller Modelo Listar Unico');
      console.log(ModeloId);

      const response = await Api.get(`api/modelo/ListarUnico/${ModeloId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: ModeloRequest): Promise<Response> {
    try {
      console.log('Controller Modelo Adicionar');
      console.log(request);

      const response = await Api.post(`api/modelo/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: ModeloRequest): Promise<Response> {
    try {
      console.log('Controller Modelo Atualizar');
      console.log(request);

      const response = await Api.put(`api/modelo/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: ModeloRequest): Promise<Response> {
    try {
      console.log('Controller Modelo Excluir');
      console.log(request);

      const response = await Api.put(`api/modelo/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default ModeloController;
